import { EngagementLetterActions } from './actions'
import { EngagementLetterGetters } from './getters'
import { EngagementLetterMutations } from './mutations'
import { EngagementLetterState } from './state'

export const ENGAGEMENT_LETTER_NAMESPACE = 'engagementLetter'

export const EngagementLetter = {
  actions: EngagementLetterActions,
  getters: EngagementLetterGetters,
  mutations: EngagementLetterMutations,
  namespaced: true,
  state: EngagementLetterState,
}
